import { ActivatedRouteSnapshot } from '@angular/router';
import {
	AccountingBasesOption,
	CountiesOption,
	FilterByNameOption,
	GovernmentTypeOption, Option,
	ShowLocalGovernmentsOnlyOption
} from '../reports/option';

import {GarfieldOptionsBundle} from '../reports/garfield-options-bundle';
import {Memoize} from 'typescript-memoize';
import {GovernmentType} from '../../services/api/fit-api/models/government-type';
import {County} from '../../services/api/fit-api/models/snapshots/county';
import {AccountingBasis} from '../../services/api/fit-api/models/accounting-basis';

export class GarfieldGovernmentList extends GarfieldOptionsBundle {
	_optionRefs = [FilterByNameOption, GovernmentTypeOption, ShowLocalGovernmentsOnlyOption, CountiesOption, AccountingBasesOption];

	@Memoize()
	get options(): Array<Option> {
		return this._optionRefs.map(option => new option(this));
	}

	constructor(
		public override readonly route: ActivatedRouteSnapshot,
		public readonly governmentTypes?: GovernmentType[],
		public readonly counties?: County[],
		public readonly accountingBases?: AccountingBasis[],
	) {
		super(route);
	}
}
